import { render, staticRenderFns } from "./library-header.vue?vue&type=template&id=43003565&scoped=true"
import script from "./library-header.vue?vue&type=script&setup=true&lang=js"
export * from "./library-header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./library-header.vue?vue&type=style&index=0&id=43003565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43003565",
  null
  
)

export default component.exports